
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M117.1 86.1c-12.6 1.6-29.7 8.4-39.1 15.3-11.9 8.9-23.2 23.3-28.8 36.8C42.9 153.4 43 151.4 43 256s-.1 102.6 6.2 117.8c7.6 18.3 22.4 34.3 39.9 43.1 5.7 2.8 14.2 6.2 18.9 7.4l8.5 2.2H256c153.9 0 143.4.4 159.8-6.2 20.6-8.2 38.4-25.9 47-46.4 6.3-15.3 6.2-13.2 6.2-117.9 0-82.9-.2-96.1-1.6-102.8-3.4-16.7-12-31.9-25.1-44.3-11.3-10.8-22.8-17.1-39.4-21.6-5.9-1.6-17.1-1.7-142.9-1.9-75.1-.1-139.4.2-142.9.7m282.2 44.8c11.2 4.5 20.8 14.4 24.9 25.8 1.7 4.6 2.2 8.9 2.6 20.5l.4 14.8H85v-11.3c0-6.2.5-14 1.1-17.3 2.2-12.1 9.6-22.9 20-29.1 10.9-6.5 2.7-6.2 151.9-6l135.5.2zm27.5 161.3c-.3 56.2-.3 57.4-2.5 63.1-4.3 11.5-13.9 21.4-25 25.8l-5.8 2.4-134.9.3c-119.3.2-135.6.1-141-1.3-16.1-4.1-28.5-17.4-31.5-33.9-.7-3.9-1.1-25.1-1.1-59.8V235h342.1z"}}),_c('path',{attrs:{"d":"M290 300.6c-16.7 7.2-16.5 31.8.2 38.9 5.6 2.3 75.1 2.3 80.6-.1 17-7 17.6-30 1-38.5-3.5-1.8-6.2-1.9-41-1.9-31.1.1-37.9.3-40.8 1.6"}})])
          )
        }
      }
    